import React, { FC } from 'react'

import { FieldErrors, UseFormClearErrors, UseFormRegister, UseFormWatch } from 'react-hook-form'
import { UseFormSetValue } from 'react-hook-form/dist/types/form'

import {
  ProjectBasicInfoInputArea,
  ProjectLocationInputArea,
  ProjectBuildingInputArea,
} from 'src/components/molecules'

import { ProjectStatusType, UpsertProjectFormEntity } from 'src/types'
import { EmailDomainEntity } from 'src/types/entities/EmailDomain'

function Line() {
  return <hr className="tw-border-border-secondary" />
}

type Props = {
  projectStatuses: ProjectStatusType[]
  currentStatus?: ProjectStatusType
  emailDomains: EmailDomainEntity[]
  register: UseFormRegister<UpsertProjectFormEntity>
  watch: UseFormWatch<UpsertProjectFormEntity>
  setValue: UseFormSetValue<UpsertProjectFormEntity>
  formErrors: FieldErrors<UpsertProjectFormEntity>
  clearErrors: UseFormClearErrors<UpsertProjectFormEntity>
  className?: string
}

export const UpsertProjectBasicInformationInputArea: FC<Props> = ({
  projectStatuses,
  currentStatus,
  emailDomains,
  register,
  watch,
  setValue,
  formErrors,
  clearErrors,
  className,
}) => {
  return (
    <div className={className}>
      <div className="tw-grid tw-gap-s3">
        <ProjectBasicInfoInputArea
          projectStatuses={projectStatuses}
          currentStatus={currentStatus}
          emailDomains={emailDomains}
          register={register}
          watch={watch}
          setValue={setValue}
          formErrors={formErrors}
        />
        <Line />
        <ProjectLocationInputArea
          register={register}
          watch={watch}
          setValue={setValue}
          formErrors={formErrors}
          clearErrors={clearErrors}
        />
        <Line />
        <ProjectBuildingInputArea register={register} formErrors={formErrors} />
      </div>
    </div>
  )
}
